module.exports = __webpack_public_path__ + "static/media/footer_8.8c0f9f81.png";